// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2MHCb","requiredAsterisk":"Info_requiredAsterisk__3_wEo"};